
import { Options, Vue } from "vue-class-component";
import { PRICING_EXCHANGE_RATE } from "@/app/infrastructures/misc/RolePermission";
import { ExchangeRateController } from "@/app/ui/controllers/ExchangeRateController";
import checkRolePermission from "@/app/infrastructures/misc/common-library/CheckRolePermission";
import formatDateWithoutTime from "@/app/infrastructures/misc/common-library/FormatDateWithoutTime";
import formatInputMoneyWithDecimalV2 from "@/app/infrastructures/misc/common-library/FormatInputMoneyWithDecimalV2";
import router from "@/app/ui/router";
import EmptyState from "@/app/ui/components/empty-list/index.vue";
import SelectSearchV2 from "@/app/ui/components/select-search/index.vue";
import { LocationController } from "@/app/ui/controllers/LocationController";
import { CountryData } from "@/domain/entities/Location";
import debounce from "lodash/debounce";
import { rateStatus } from "@/app/infrastructures/misc/common-library/ExchangeRate";

@Options({
  components: {
    EmptyState,
    SelectSearchV2
  },
  computed: {
    getCurrentRoute() {
      return this.$route.meta.title;
    },
    isCreateAble() {
      return checkRolePermission(PRICING_EXCHANGE_RATE.CREATE) && !this.isError;
    },
    isDetailAble() {
      return checkRolePermission(PRICING_EXCHANGE_RATE.DETAIL);
    }
  }
})
export default class ExchangeRate extends Vue {
  // filter status
  statusData = [
    { name: "Semua Status", value: "" },
    { name: "Menunggu", value: "pending" },
    { name: "Aktif", value: "active" },
    { name: "Nonaktif", value: "inactive" }
  ];
  statusSelect = false;
  statusName = "";
  onOpenStatusSelect() {
    this.statusSelect = true;
  }
  onCloseStatusSelect() {
    this.statusSelect = false;
  }
  onSelectStatus(name: string, value: string) {
    this.statusName = name;
    this.onCloseStatusSelect();
    ExchangeRateController.setStatusAction(value);
  }

  setRateStatus(status: 'active' | 'pending' | 'inactive') {
    return rateStatus(status)
  }

  // filter kurs awal & kurs tukar — searchable Country picker (Active countries only)
  kursAwal: any = "";
  onSelectKursAwal(object: any) {
    this.kursAwal = object;
    ExchangeRateController.setFromAction(object?.value || "");
  }

  kursTukar: any = "";
  onSelectKursTukar(object: any) {
    this.kursTukar = object;
    ExchangeRateController.setToAction(object?.value || "");
  }

  fetchCountryCurrency = debounce((search: string) => {
    LocationController.getCountryList({
      search: search,
      status: "active",
      page: 1,
      limit: 10
    });
  }, 250);

  get isLoadingCountry() {
    return LocationController.isLoadingCountry;
  }

  get countryListData() {
    return LocationController.countryData.countryData.map((e: CountryData) => {
      return {
        name: `${e.name} - ${e.currency}`,
        nameOnly: e.name,
        currency: e.currency,
        value: e.currency
      };
    });
  }

  get fromCountryListData() {
    if (this.kursTukar.value) {
      return this.countryListData.filter((country) => {
        return country.currency !== this.kursTukar.value
      })
    }

    return this.countryListData;
  }

  get toCountryListData() {
    if (this.kursAwal.value) {
      return this.countryListData.filter((country) => {
        return country.currency !== this.kursAwal.value
      })
    }

    return this.countryListData;
  }

  // data list
  mounted() {
    ExchangeRateController.initExchangeRates();
  }

  onRequest() {
    ExchangeRateController.fetchExchangeRate();
  }

  get firstRequest() {
    return ExchangeRateController.firstRequest;
  }

  get exchangeData() {
    return ExchangeRateController.exchangeRateData.data;
  }

  // Table
  columns = [
    // {
    //   name: "ID Rate",
    //   key: "id",
    //   styleHead: "w-2/12 text-left whitespace-no-wrap",
    //   styleBody: "text-red-lp-200 text-center",
    //   render: (item: any) => {
    //     return `<span class='text-left text-red-lp-200 flex'>${item.id}</span>`;
    //   }
    // },
    {
      name: "Kurs Awal",
      styleHead: "w-2/12 whitespace-no-wrap text-left",
      styleBody: "",
      render: (item: any) => {
        return `<div class="flex text-black-lp-300">
                    <div class="rounded px-2 py-0 bg-gray-lp-400 font-medium">${item.exchangeRateFrom}</div>
                </div>`;
      }
    },
    {
      name: "Kurs Tukar",
      key: "kursTukar",
      styleHead: "w-2/12 text-left whitespace-no-wrap",
      styleBody: "rounded py-0",
      render: (item: any) => {
        return `<div class='text-black-lp-300 flex'>
                    <div class="rounded px-2 py-0 bg-gray-lp-400 font-medium">${item.exchangeRateTo}</div>
                </div>`;
      }
    },
    {
      name: "Nilai Tukar",
      key: "nilaiPenukaran",
      styleHead: "w-2/12 text-left whitespace-no-wrap",
      render: (item: any) => {
        return `<div class='flex text-black-lp-300'>${formatInputMoneyWithDecimalV2(
          item.exchangeRate,
          6,
          item.exchangeRateTo
        )}</div>`;
      }
    },
    {
      name: "Tanggal Efektif",
      key: "effectiveDate",
      styleHead: "w-2/12 text-left",
      styleBody: "text-left rounded py-0",
      render: (item: any) => {
        return `<div class='flex text-black-lp-300 whitespace-no-wrap'>${formatDateWithoutTime(
          item.effectiveDate
        )}</div>`;
      }
    },
    {
      name: "Status",
      key: "status",
      styleHead: "w-2/12 text-left",
      styleBody: "",
      render: (item: any) => {
        return `
         <div class="flex">
      <div
        class="rounded-full px-2 py-0 ${this.getClassBasedOnStatus(
          item.status.toLowerCase()
        )}"
      ><span class="capitalize font-medium">${this.setRateStatus(item.status.toLowerCase())}</span></div></div>`;
      }
    }
  ];
  getClassBasedOnStatus(status: string) {
    if (status === "active") return "bg-green-lp-300 text-green-lp-200";
    if (status === "inactive") return "bg-red-300 text-red-lp-200";
    return "bg-yellow-lp-200 text-yellow-lp-100";
  }

  // to detail page
  onClickRow(item: any) {
    this.$router.push(`/tarif/exchange-rate/${item.id}`);
  }

  // to Add Page
  toPageAdd() {
    router.push(`/tarif/exchange-rate/add`);
  }

  // Pagination Table
  get pagination() {
    return ExchangeRateController.exchangeRateData.pagination;
  }

  //Loading
  get isLoading() {
    return ExchangeRateController.isLoading;
  }

  //Error
  get isError() {
    return ExchangeRateController.isError;
  }

  //Error Cause
  get errorCause() {
    return ExchangeRateController.errorCause;
  }
}
